export default __webpack_public_path__ + "d4c92b821c6a5cc9b5a0ada4b6463f54.png";